import React, { useEffect, useState } from 'react';

const LoadingScreen = ({ onComplete, duration = 2400 }) => {
  const [layoutIndex, setLayoutIndex] = useState(0);

  const layouts = [
    <div key="0" className="w-full h-full bg-gray-200 p-4 grid grid-cols-4 gap-4 opacity-50">
      <div className="col-span-4 h-20 bg-blue-800"></div>
      <div className="col-span-1 h-full bg-gray-400"></div>
      <div className="col-span-3 h-full bg-white grid grid-cols-2 gap-4 p-4">
        <div className="h-32 bg-gray-300"></div>
        <div className="h-32 bg-gray-300"></div>
        <div className="col-span-2 h-64 bg-gray-800"></div>
      </div>
    </div>,
    <div key="1" className="w-full h-full bg-red-900 p-0 flex flex-col opacity-60">
      <div className="flex-grow bg-black relative overflow-hidden">
        <div className="absolute top-0 left-0 w-full h-full border-[20px] border-white"></div>
      </div>
      <div className="h-32 bg-white border-t-4 border-black flex items-center justify-between px-10">
        <div className="h-4 w-1/2 bg-black"></div>
      </div>
    </div>,
    <div key="2" className="w-full h-full bg-yellow-400 p-2 grid grid-cols-6 grid-rows-6 gap-1 opacity-70">
      <div className="col-span-2 row-span-6 bg-black"></div>
      <div className="col-span-4 row-span-1 bg-white"></div>
      <div className="col-span-2 row-span-2 bg-pink-500"></div>
      <div className="col-span-2 row-span-2 bg-purple-500"></div>
      <div className="col-span-4 row-span-3 bg-green-600"></div>
    </div>,
    <div key="3" className="w-full h-full bg-white p-10 flex flex-col justify-between opacity-40">
      <div className="w-full h-2 bg-black mb-2"></div>
      <div className="w-full h-2 bg-black mb-2"></div>
      <div className="w-full h-2 bg-black mb-2"></div>
      <div className="w-full h-64 bg-gray-100 border border-black"></div>
    </div>,
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setLayoutIndex((prev) => (prev + 1) % layouts.length);
    }, 120);
    const timer = setTimeout(() => onComplete && onComplete(), duration);
    return () => {
      clearInterval(interval);
      clearTimeout(timer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black overflow-hidden">
      <div className="absolute inset-0 w-full h-full pointer-events-none filter blur-[1px] scale-105">
        {layouts[layoutIndex]}
      </div>
      <div className="relative z-10 flex flex-col items-center">
        <img
          src="/owlfit-logo.png"
          alt="OWLFIT"
          className="w-full max-w-sm md:max-w-md object-contain animate-pulse drop-shadow-[0_0_30px_rgba(168,85,247,0.6)]"
          draggable="false"
        />
        <div className="mt-2 bg-white text-black px-4 py-1 font-mono font-bold text-sm uppercase tracking-widest border-2 border-black shadow-[4px_4px_0px_white]">
          Initializing Interface...
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;
